import { IconButton, styled } from "@mui/material";
import { useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { ResultOf, graphql } from "@/config/graphql";
import { useQuery } from "@apollo/client";
import { Table, TableCell, TableContainer, TableRow } from "@/components/Table";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";

const Fab = styled("button")`
  background: #2196f3;
  color: white;
  width: 24px;
  height: 24px;
  min-height: 24px;
  margin: auto;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  display: block;
  padding: 0;
  transition: 0.3s;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    background: #1976d2;
  }
`;

export const currentFuelControlQuery = graphql(`
  query currentFuelControl($params: ReportParams!) {
    report(params: $params) {
      id
      fuelControlDetails {
        id
        resourceName
        initialHourometer
        finalHourometer
        diesel
        dieselHourometer
        dieselLastHourometer
        hours
        performance
        resourceDetail
        type
        performanceRange {
          min
          max
        }
      }
    }
  }
`);
interface FuelTableProps {
  onEdit?: (
    detail: NonNullable<
      ResultOf<typeof currentFuelControlQuery>["report"]["fuelControlDetails"]
    >[number]
  ) => void;
}
export const FuelTable = (props: FuelTableProps) => {
  const params = useParams();
  const { data } = useQuery(currentFuelControlQuery, {
    variables: { params: { id: +(params.id ?? 0) } },
    fetchPolicy: "cache-only",
  });
  console.log(data?.report?.fuelControlDetails?.map((e) => e.performanceRange));
  return (
    <TableContainer>
      <Table>
        <thead>
          <TableRow variant="mainHeader">
            <TableCell sx={{ minWidth: 40 }}></TableCell>
            <TableCell>Equipos</TableCell>
            <TableCell>Rendimiento [lt/hr]</TableCell>
            <TableCell>Diesel (lt)</TableCell>
            <TableCell>Horas</TableCell>
            <TableCell>Horómetro de carga</TableCell>
            <TableCell>Horómetro última carga</TableCell>
            <TableCell>Horómetro inicial</TableCell>
            <TableCell>Horómetro final</TableCell>
          </TableRow>
        </thead>
        <tbody>
          {data?.report?.fuelControlDetails?.map((detail, index) => {
            return (
              <TableRow key={index} onClick={() => props.onEdit?.(detail)}>
                <TableCell>
                  {props.onEdit && detail.id > 0 && (
                    <IconButton sx={{ color: "#333333" }}>
                      <CreateOutlinedIcon />
                    </IconButton>
                  )}
                  {props.onEdit && detail.id < 0 && (
                    <Fab>
                      <AddIcon />
                    </Fab>
                  )}
                </TableCell>
                <TableCell>
                  {detail.resourceName}{" "}
                  {detail.resourceDetail ? `(${detail.resourceDetail})` : ""}
                </TableCell>
                <TableCell
                  computedValue
                  textAlign="center"
                  sx={(theme) => ({
                    color: !detail.performance
                      ? ""
                      : detail.performanceRange?.min &&
                        detail.performance < detail.performanceRange.min
                      ? theme.palette.error.main
                      : detail.performanceRange?.max &&
                        detail.performance >= detail.performanceRange.max
                      ? theme.palette.success.main
                      : theme.palette.warning.main,
                  })}
                >
                  {detail.id > 0 &&
                    detail.diesel &&
                    detail.type !== "ONLY_DIESEL" &&
                    detail.performance?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.id > 0 && detail.diesel}
                </TableCell>
                <TableCell computedValue textAlign="center">
                  {detail.id > 0 &&
                    detail.diesel &&
                    detail.type !== "ONLY_DIESEL" &&
                    detail.hours}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.id > 0 && detail.dieselHourometer}
                </TableCell>
                <TableCell computedValue textAlign="center">
                  {detail.id > 0 && detail.dieselLastHourometer}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.id > 0 && detail.initialHourometer}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.id > 0 && detail.finalHourometer}
                </TableCell>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
    </TableContainer>
  );
};
